<template>
  <v-layout
    :title="$t('sign_up_help.title')"
    :subtitle="$t('sign_up_help.subtitle')"
  >
    <HelpPage :topics="topics" />
  </v-layout>
</template>


<script>
import VLayout from "@/layouts/Default";
import HelpPage from "@/components/HelpPage";

export default {
  components: {
    VLayout,
    HelpPage,
  },
  computed: {
    topics() {
      return [
        {
          title: this.$t("sign_up_help.without.title"),
          text: this.$t("sign_up_help.without.content"),
        },
        {
          title: this.$t("sign_up_help.offers.title"),
          text: this.$t("sign_up_help.offers.content"),
        },
        {
          title: this.$t("sign_up_help.sign_up.title"),
          text: this.$t("sign_up_help.sign_up.content"),
        },
      ];
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        sign_up_help: {
          title: "Sign up",
          subtitle: "Signing up is very easy!",
          breadcrumb: "Sign up",
          invited: "I was invited to sign up to Vooy Market",
          without: {
            title: "Shop without sign up",
            content: "",
          },
          sign_up: {
            title: "Sign up",
            content: "",
          },
          offers: {
            title: "Receive our offers",
            content: "",
          },
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
</style>
